import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MetaInfo from "vue-meta-info"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import { POST, GET } from './api/http';
// import $ from 'jquery'
// import 'bootstrap'

// 引入bootstrap样式
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.min.js'

// 全局注册 $

import './assets/css/main.css'

import './assets/css/index.css'
// import './assets/js/vendor/jquery.min.js'
// import './assets/js/vendor/bootstrap.min.js'
Vue.config.productionTip = false
Vue.prototype.$post = POST;
Vue.prototype.$get = GET;
// Vue.prototype.$ = $

Vue.use(MetaInfo);
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App),
	// mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
	// mounted() {
	// 	document.dispatchEvent(new Event('render-event'))
	// },
}).$mount('#app')
